// setBrowserPermissionData.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set browser permission data
 * @kind action
 * @param {string} {permissionKey} - browser permission type. like: notification.
 * @param {string} {permissionState} - state of permissionKey.
 * @return {Promise} Action promise.
 */
const setBrowserPermissionData =
  ({ permissionKey, permissionState }) =>
  async dispatch => {
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['permission'],
        data: {
          [permissionKey]: permissionState,
        },
      },
    });
  };

export default setBrowserPermissionData;
